import { render, staticRenderFns } from "./UserComponent.vue?vue&type=template&id=32125d02&scoped=true"
import script from "./UserComponent.vue?vue&type=script&lang=js"
export * from "./UserComponent.vue?vue&type=script&lang=js"
import style0 from "./UserComponent.vue?vue&type=style&index=0&id=32125d02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32125d02",
  null
  
)

export default component.exports